// extracted by mini-css-extract-plugin
module.exports = {"main":"EmpCarousel_main__2zIvF","card":"EmpCarousel_card__7kYlo","imgClass":"EmpCarousel_imgClass__3LGpb","car":"EmpCarousel_car__2DF8z","btns":"EmpCarousel_btns__eSorD"};